module.exports = __webpack_public_path__ + "static/media/platinum.22d2e83b.mp4";